import script from "./PresenterView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PresenterView.vue?vue&type=script&lang=ts&setup=true"

import "./PresenterView.vue?vue&type=style&index=0&id=90c37f7c&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c37f7c"]])

export default __exports__